export const DRAWER_SHOW_TYPE_RESOURCE = {
    'tag-category-show': 'tag-category',
    'material-show': 'material',
    'ad-show': 'ad',
    'contractor-show': 'contractor',
    'user-show': 'user',
    'spare-part-show': 'spare-part',
    'software-alias-show': 'software-alias',
    'software-update-rule-show': 'software-update-rule',
    'parameter-show': 'parameter',
    'device-model-show': 'device-model',
    'retail-chain-show': 'retail-chain',
    'brand-show': 'brand',
};

export const canViewDetails = (resource, permissions = {}) => {
    const { isAdmin, isBok, isClient, isClientMaster, isServiceMaster, isPosOwner } = permissions;

    switch (resource) {
        case 'tag-category':
        case 'material':
        case 'contractor':
        case 'spare-part':
        case 'software-alias':
        case 'software-update-rule':
        case 'parameter':
        case 'device-model':
        case 'retail-chain':
        case 'brand':
            return Boolean(isAdmin || isBok);
        case 'ad':
            return Boolean(isAdmin || isBok || (isClient && !isPosOwner));
        case 'user':
            return Boolean(isAdmin || isBok || isClientMaster || isServiceMaster);
        default:
            return false;
    }
};

export const canViewDrawerShow = (type, permissions) => {
    const resource = DRAWER_SHOW_TYPE_RESOURCE[type];
    if (!resource) {
        return true;
    }

    return canViewDetails(resource, permissions);
};
